import { render } from "./ProductAdd.vue?vue&type=template&id=bea25da2"
import script from "./ProductAdd.vue?vue&type=script&lang=js"
export * from "./ProductAdd.vue?vue&type=script&lang=js"

import "./ProductAdd.vue?vue&type=style&index=0&id=bea25da2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__